(ns rothko.editor.document.history.linear
  (:require [com.rpl.specter :as sp]
            [rothko.editor.document.navigator :refer [selectionnav]]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.document.paths :as paths]
            [rothko.editor.document.script :as script]))

(defn attach-to-document
  [document]
  (assoc document
         :index 0
         :history [document]))

(defn remove-from-document
  [document]
  (dissoc document :index :history))

(def append*
  (selectionnav
   [transform]
   (transform*
    [_ {:keys [] :as selection} structure next-fn]
    (sp/transform
     ;; When we apply an editor action that has an effect on the history we ...
     (sp/multi-path
      ;; ... do the wrapped transform ...
      (sp/with-fresh-collected
       transform)
      ;; ... then check if the transformation actually produces a different script
      ;; and only in that case proceed ...
      (sp/if-path
       [:script (fn [new-script] (not= new-script (:script structure)))]
       (sp/multi-path
        ;; ... to inc the history index ...
        [:index
         (sp/terminal
          inc)]
        ;; ... then truncate the history from the new index ...
        ;; (We do this so that if we make changes to the document when
        ;; we're in the middle of the history, i.e. after some undos, we
        ;; discard the now invalid history and carry on building the
        ;; history from this point).
        [(sp/collect-one
          :index)
         :history
         (sp/terminal
          (fn [index history]
            (subvec history 0 index)))]
        ;; ... and finally we attach the new document state to the head of
        ;; the history stack
        [(sp/collect-one
          (sp/submap [:script :selection]))
         :history
         (sp/terminal
          (fn [new-script-and-selection history]
            (let [last-entry (-> history
                                 peek
                                 (assoc :updated-selection (:selection structure)))]
              (-> history
                  pop
                  (conj last-entry)
                  (conj new-script-and-selection)))))])))
     next-fn
     structure))))

(defn append
  [transform]
  (sp/with-fresh-collected
    [(sp/collect-one :selection)
     (append* transform)]))

(defn append-script
  [document script]
  (let [transform (sp/multi-path
                   [:script (sp/terminal-val script)]
                   [:selection (sp/terminal-val (script/caret 0 0))])]
    (sp/multi-transform
     (append transform)
     document)))

(defn navigate-history
  [action index]
  (let [[direction selection-key] (case action
                                    :undo [dec :updated-selection]
                                    :redo [inc :selection])
        new-index (direction index)]
    ;; We check whether there is an element in the history at the new index,
    ;; so we know whether we can travel in that direction,
    ;; and only if there is ...
    (sp/if-path
     [:history (sp/index-nav new-index)]
     (sp/multi-path
      ;; ... we navigate the history (by updating the index) ...
      [:index
       (sp/terminal-val
        new-index)]
      ;; ... and collect the document at that index ...
      [(sp/collect-one
        :history
        (sp/nthpath new-index))
       (sp/multi-path
        [:script
         (sp/terminal
          (fn [{:keys [script] :as historical-script-and-selection} _]
            ;; ... and simply replace the current script ...
            script))]
        [:selection
         (sp/terminal
          (fn [historical-script-and-selection _]
            ;; ... and selection with what we collect above.
            (selection-key historical-script-and-selection)))])]))))

(sp/defnav navigate
  [name]
  (select*
   [_ structure next-fn]
   (next-fn structure))
  (transform*
   [_ structure next-fn]
   (sp/transform
    (navigate-history name (:index structure))
    next-fn
    structure)))
